export {
  createSESSdk,
  type SESConfig,
  type EmailParams,
  type BulkEmailParams,
  type SendEmailResponse,
  type SESSDK,
} from './aws-ses-sdk';

export { default } from './aws-ses-sdk';
